import React, { FunctionComponent, useContext, useEffect, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import { useHistory } from "react-router-dom";
import { getManagerInfo, getNominatorInfo, getUserCity, getUserCompany, getUserRoleId, validateNominee } from './services';
import { getAutoSaveVal, getCategoryMap, getFirstName, getMiddleName, getNominatorId, getNominatorMail, setAutoSaveVal, setIsAnonymous } from './common';
import { Alert, AlertTitle } from '@material-ui/lab';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { Modal } from '@material-ui/core';
import { data } from './local';
import { useSelector } from 'react-redux';
import { appInsights } from '../AppInsights';
import { LineScalePulseOut } from 'react-pure-loaders';
import styles from "./Common.module.scss"
interface CountryType {
  name: string;
  id: any;
  jobTitle?: string;
}

function sleep(delay = 0) {
  return new Promise((resolve) => {
    setTimeout(resolve, delay);
  });
}



export const UserImage: FunctionComponent<any> = ({ id, token }: any) => {

  const [image, setImage] = useState<any>();
  useEffect(() => {
    let url = `https://graph.microsoft.com/v1.0//users/${id}/photo/$value`;
    let icon;
    (async () => {
      if (token && id) {
        icon = fetch(url, {
          method: 'GET',
          headers: {
            Authorization: 'Bearer ' + token,
            "Content-Type": "image/jpg"
          },
        }).then(async (response: any) => {
          if (response.ok) {
            return response.blob();
          }
          if (response?.status == 200) {
            let data = response.body
          }
        }).then((photoBlob: any) => {
          let icon;
          if (photoBlob) {
            icon = URL.createObjectURL(photoBlob);
            setImage(icon)
          } else {
            icon = "/images/758772.svg";
          }
        });
      }
    })();


  }, [id, token])
  return image ? <img id={id} style={{
    width: "44px",
    height: "inherit",
    margin: "auto",
    borderRadius: "50%",
    marginRight: "5px"

    // width: "39px",
    // borderRadius: "20px"
  }} src={image} alt="noImage" /> :


    <AccountCircleIcon style={{
      height: "50px",
      width: "50px",
      borderRadius: "20px"
    }} />
  // <div style={{
  //   width: "45px",
  //   height: "45px",
  //   borderRadius: "50%",
  //   background: "grey"
  // }}></div>


}
const SearchBox: FunctionComponent<any> = ({ title, token}: any) => {

  const [value, setValue] = useState<any>();  
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState<CountryType[]>([{ name: "India", id: "ds" }, { id: "dsad", name: "USA" }]);
  const loading = open && options.length === 0 && value;
  const [isLoading, setLoading] = useState<boolean>(false);
  const [loader, setLoader] = React.useState(false);
  
  React.useEffect(() => {
    let active = true;
    let filter = `(startswith(displayName,'${value}') or startswith(givenName,'${value}') or startswith(surname,'${value}') or startswith(mail,'${value}') or startswith(userPrincipalName,'${value}')) and (mail ne null)`;
    if (value) {
      // return undefined;
      setLoading(true);
    } else {
      setLoading(false);
    }

    if(value!=undefined){
      if(value.length>=3){
        (async () => {
          var url = "https://graph.microsoft.com/v1.0/users?$count=true&$orderby=displayName&$filter="+filter;
          if (token) {
            fetch(url, {
              method: 'GET',
              headers: {
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json',
                'ConsistencyLevel': 'eventual'
              },
            }).then(async (response: any) => {
           
              const data = await response.json()
              if (active) {
                if (data?.value?.length > 0) {
                  setOptions(data?.value.map((user: any) => {
                    const { mail,
                      officeLocation,
                      surname } = user;
    
                    return ({
                      name: user.displayName,
                      id: user.id,
                      jobTitle: user.jobTitle,
                      mail,
                      officeLocation,
                      surname
                    })
                    // return user
                  }) as CountryType[]);
                  setLoading(false);
                } else {
                  setLoading(false);
                  setOptions([]);
                }
    
              }
            })
          }
        })();
      }

  }

    return () => {
      active = false;
    };
  }, [value]);

  React.useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  let history = useHistory();


  const nomineeHandler = async (option: any, searchBox: any) => {
    setLoader(true);
  setIsAnonymous(false);
    let userInfo: any = await getNominatorInfo(option.id);
    
    let userInfoCompany: any = await getUserCompany(option.id);
    let userInfoCity: any = await getUserCity(option.id);
    let managerInfo: any = await getManagerInfo(option.id);
    let roleInfo:any= await getUserRoleId(userInfo.mail);
    const { displayName,givenName,surname, mail, officeLocation, jobTitle } = userInfo;

    if (getNominatorMail() === mail) {
      setError(true)
      setAlertTitle(searchBox.error)
      setAlertMessage(searchBox.selfNominationMsg)
      setMsgType("selfNominationMsg");
      return;
    }
    let nomineeOption = {
     
      "nominatorId": getNominatorId(),
      "categoryId": getCategoryMap().get("via nominations"),//Remove Hardcoading
      "firstName": givenName,
      "lastName": surname,
      "middleName": '',
      "displayName":displayName,
      "email": mail,
      "city": userInfoCity.value,
      "company": userInfoCompany.value,
      "title": jobTitle,
      "managerName": managerInfo.displayName,
      "managerEmail": managerInfo.mail,
      "graphId": option.id,
      "RoleId":roleInfo==0?2:roleInfo
    }

    let validationResponse: any = await validateNominee(nomineeOption);
    setLoader(false);
    if (validationResponse.isValid) {
      setIsAnonymous(validationResponse.draftMessage!=""?validationResponse.isAnonymous:false);
      setError(false)
      setAutoSaveVal(validationResponse.draftMessage);
      history.push("nominations", {
        ...option,
        token,
        nomineeId: validationResponse.nomineeId,
        nomineeManagerName: managerInfo.displayName,
        nomineeManagerEmail: managerInfo.mail,
        notes: validationResponse.draftMessage
      
      }
     )
     } else {
      setError(true)
      setAlertTitle(searchBox.error)
      setAlertMessage(searchBox.duplicateNominationMsg)
      setMsgType("duplicateNominationMsg");
      //  alert('Cannot Nominate same person twice');

    }

  }
  const [showError, setError] = useState<boolean>(false)
  const [alertTitle, setAlertTitle] = useState<string>('')
  const [alertMessage, setAlertMessage] = useState<string>('')
  const [msgType, setMsgType] = useState<string>('')
  const [userNotFoundMsg, setUserNotFoundMsg] = useState<string>('')

  const languageSelected: any = useSelector((state: any) => state.lang);

  const languageData: any = data;
  const { searchBox } = languageData[languageSelected];
  useEffect(() => {
    setAlertTitle(searchBox.error)
    setAlertMessage(searchBox[msgType])
      setUserNotFoundMsg(searchBox.userNotFound)} , 
      [languageSelected])

  const classes = useStylesSearch();

  return (
    <>
    <div className={styles.searchBoxLoader}>
                    <LineScalePulseOut
                        color={'#035295'}
                        loading={loader}
                    />
                </div>
      <Autocomplete
        inputValue={value}
        onInputChange={(event, newInputValue) => {
          setError(false)
          setOptions([])
          setValue(newInputValue);
        }}
        freeSolo={value ? false : true}
        noOptionsText={<div > 
          <span style={{ color: "#3f51b5", cursor: "pointer" }} onMouseDown={() =>{
         window.open('https://forms.office.com/Pages/ResponsePage.aspx?id=hpAxLiaao0aGX2Fb7Vdnhrzaxkpnq39EoMBesPsF0RpUNDdSRUJDRkszSDg4NVFBTDNPTlo1WEVSOS4u')} } >
           
            {userNotFoundMsg}
          </span>
       
        </div>}
        id="search"
        style={{ width: "80%"}}
        open={open}
        onOpen={() => {
          setOpen(true);
        }}
        onClose={() => {
         setOpen(true);
         setLoader(false);
        }}
        getOptionSelected={(option: any, value: any) => option.name === value.name}
        getOptionLabel={(option: any) => option.name}
        options={options}
        loading={isLoading}
        className={classes.root}
        renderOption={(option: any) => {
          
          return <div style={{ display: "flex", width: "100%" }} onClick={() => { nomineeHandler(option, searchBox) }}>
            <UserImage id={option.id} token={token} />
            <div style={{
              display: "flex",
              flexDirection: "row",
              marginLeft: "5px",
              width: "100%",
              justifyContent: "space-between"

            }}>
              <div style={{
                display: "flex",
                flexDirection: "column",
                marginLeft: "5px"

              }}>
                <div style={{
                  margin: "auto",
                  // marginLeft: "14px",

                }}> {option.name.trim(" ")}</div>
                <div style={{ fontSize: "11px" }}>{option?.jobTitle}</div>
                <div style={{ fontSize: "11px" }}>{option?.officeLocation}</div>
              </div>
                <div style={{
                position: "relative", color: "#3f51b5",
                float: "right",
                margin: "auto",
                fontSize: "12px",
                marginRight: "0px"
              }} >Nominate</div>
              
              
             
            </div>
          </div>
        }}
        renderInput={(params: any) => (
          <TextField
            {...params}
            label={title}
            InputLabelProps={{style: {fontSize: '2vmin'}}}
            variant="outlined"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {isLoading ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
      <DescriptionAlerts show={showError} error={alertTitle} message={alertMessage} onClose={() => {
        setError(false.valueOf)
      }} />
    </>
  );
}


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      '& > * + *': {
        marginTop: theme.spacing(2),
      },
      transform: "translateZ(10px)",
      zIndex: 999999999,
      boxShadow: "1px 0px 8px #878282",
      position: "relative",
      top: "5px"
    },
    [theme.breakpoints.down(650)]: {
      width: '50%',
      '& > * + *': {
        marginTop: theme.spacing(1),
      },
      transform: "translateZ(5px)",
      zIndex: 999999999,
      boxShadow: "1px 0px 8px #878282",
      position: "relative",
      top: "5px"            
    },
    hidden: {
      display: "none"
    },
  }),
);

const useStylesSearch = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor:"#FFFFFF",
      "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
        borderColor: "#00338E"
      },
      "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#00338E"
      },
      "&:hover .MuiOutlinedInput-input": {
        color: "#00338E"
      },
      "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input": {
        color: "#00338E"
      },
      "&:hover .MuiInputLabel-outlined": {
        color: "#00338E"
      },
      "& .MuiInputLabel-outlined.Mui-focused": {
        color: "#00338E"
      }
    }
  }),
);



export function DescriptionAlerts({ show, error, message }: any) {
  const classes = useStyles();

  return (
    <div className={show ? classes.root : classes.hidden}>
      <Alert severity="error">
        <AlertTitle>{error}</AlertTitle>
        {message}
      </Alert>

    </div>
  );
}


export default SearchBox;